'use strict';

const processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/details'));
    processInclude(require('./common/cart'));
    processInclude(require('./product/wishlist'));
});
